import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {greys} from "@irati/ui/src/global/colors"

const LineBackground = styled.div`
  border-bottom: 1px solid ${greys.medium};
  height: 0.1em;
  margin: ${(props) => props.imageHeight / 2}px 0;
  display: flex;
  justify-content: center;
`

const Wrapper = styled.div`
  background: ${greys.white};
  ${(props) => `
    padding: 0 ${props.padding}px;
    width: ${props.imageWidth + props.padding * 2}px;
    height: ${props.imageHeight}px;
    margin-top: -${props.imageHeight / 2}px;
  `}
`

const ImageDivider = ({imageWidth, imageHeight, children, padding}) => {
  return <LineBackground imageHeight={imageHeight}>
    <Wrapper imageWidth={imageWidth} imageHeight={imageHeight} padding={padding}>
      {children}
    </Wrapper>
  </LineBackground>
}

ImageDivider.propTypes = {
  imageWidth: PropTypes.number.isRequired,
  imageHeight: PropTypes.number.isRequired,
  children: PropTypes.object.isRequired,
  padding: PropTypes.number
}

ImageDivider.defaultProps = {
  padding: 8
}

export default ImageDivider
